module.exports = __webpack_public_path__ + "media/images/flags/32/Peru-3db0fdfea9f13a01598e3300f9d4796e.png";